module.exports = __webpack_public_path__ + "static/media/gautam.77e2dc00.jpg";